import { render, staticRenderFns } from "./card-payment.vue?vue&type=template&id=067619b0&scoped=true&"
import script from "./card-payment.vue?vue&type=script&lang=js&"
export * from "./card-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067619b0",
  null
  
)

export default component.exports